import { render, staticRenderFns } from "./leaveApproval.vue?vue&type=template&id=34c421a5&"
import script from "./leaveApproval.vue?vue&type=script&lang=js&"
export * from "./leaveApproval.vue?vue&type=script&lang=js&"
import style0 from "./leaveApproval.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports